// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailsTemplate_container__ItDAR"};